export enum RequestStatus {
  SUCCESS = "Success",
  FAILURE = "Failure",
  LOADING = "Loading",
  ALREADY_EXISTs = "AlreadyExists",
}
